export default function SentIcon() {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.79425 9.20487L10.9762 6.02289M14.7825 1.52259L1.68129 5.21779C1.57107 5.24888 1.47297 5.31286 1.40009 5.4012C1.32721 5.48953 1.28303 5.59801 1.27346 5.71212C1.26388 5.82624 1.28936 5.94056 1.34649 6.03981C1.40363 6.13905 1.48969 6.2185 1.59319 6.26752L7.6127 9.11887C7.7301 9.17448 7.82464 9.26902 7.88025 9.38642L10.7316 15.4059C10.7806 15.5094 10.8601 15.5955 10.9593 15.6526C11.0586 15.7098 11.1729 15.7352 11.287 15.7257C11.4011 15.7161 11.5096 15.6719 11.5979 15.599C11.6863 15.5261 11.7502 15.428 11.7813 15.3178L15.4765 2.21666C15.5037 2.12043 15.5047 2.01869 15.4794 1.92194C15.4542 1.82519 15.4036 1.73692 15.3329 1.66622C15.2622 1.59551 15.1739 1.54493 15.0772 1.51969C14.9804 1.49444 14.8787 1.49544 14.7825 1.52259Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
